module.exports = __webpack_public_path__ + "static/ha-452c41b80f485207d10a8303a72d625d.jpg";